import './App.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home/Home';
import Profile from './pages/Profile/Profile';
import History from './pages/History/History';
import Works from './pages/Works/Works';
import AboutSite from './pages/AboutSite/AboutSite';
import Contact from './pages/Contact/Contact';
import ProductSushiwari from './pages/Works/ProductPages/ProductSushiwari';
import ProductShinagawaRunners from './pages/Works/ProductPages/ProductShinagawaRunners';
import ProductOfficeDx from './pages/Works/ProductPages/ProductOfficeDx';
import ProductBeRehearsal from './pages/Works/ProductPages/ProductBeRehearsal';
import ProfileHobby from './pages/Profile/ProfileHobby';


const App = () => {
  return (
    <Router>
      <>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/history" element={<History />} />
          <Route path="/works" element={<Works />} />
          <Route path="/AboutSite" element={<AboutSite />} />
          <Route path="/contact" element={<Contact />} />

          <Route path="/profile/hobby" element={<ProfileHobby />} />

          <Route path="/works/sushiwari" element={<ProductSushiwari />} />
          <Route path="/works/shinagawa-runners" element={<ProductShinagawaRunners />} />
          <Route path="/works/office-dx" element={<ProductOfficeDx />} />
          <Route path="/works/berehearsal" element={<ProductBeRehearsal />} />
        </Routes>
      </>
    </Router>
  );
}

export default App;
